import { createFileRoute } from '@tanstack/react-router';
import { SuggestionsPage } from '#features/suggestions/suggestions-page';

export const Route = createFileRoute('/_authed/suggestions')({ component: SuggestionsPage });
